import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'is',
})
export class IsPipe implements PipeTransform {
  transform(value: any, valueToCheck: any): boolean {
    if (value === valueToCheck) return true;
    return false;
  }
}
